export default {
    inQueue: 'In queue',
    inProgress: 'In Progress'
};
